import { field, formatUnits, parseUnits, readContract, writeContractAndWait } from "../viem";

import config from "../../config/config";

import MafiaShopAbi from "../../abis/MafiaShop.json";

const address = config.shop;
const abi = MafiaShopAbi;

export const getShopItems = async (cityId: number) => {
  const shopItems = [];

  let basePrices: number[] = [];
  let ownerPrices: number[] = [];

  try {
    const cityPrices: any = await readContract({
      address,
      abi,
      functionName: "getCityPrices",
      args: [cityId],
    });
    const rawBasePrices = field<string[]>(cityPrices, "basePrices", 0) || [];
    const rawOwnerPrices = field<string[]>(cityPrices, "onwerPrices", 1) || [];
    basePrices = rawBasePrices.map((price: string) => Number(formatUnits(price, 18)));
    ownerPrices = rawOwnerPrices.map((price: string) => Number(formatUnits(price, 18)));
  } catch (error) {
    console.log("getCityPrices failed", error);
    basePrices = [];
    ownerPrices = [];
  }

  const shopItemsResponse: any = await readContract({
    address,
    abi,
    functionName: "getShopItems",
    args: [cityId],
  });

  const categoryIds = (field<string[]>(shopItemsResponse, "categoryIds", 0) || []).map(
    (value: string) => Number(value)
  );
  const typeIds = (field<string[]>(shopItemsResponse, "typeIds", 1) || []).map(
    (value: string) => Number(value)
  );
  const stockAmounts = (field<string[]>(shopItemsResponse, "stockAmounts", 2) || []).map(
    (value: string) => Number(value)
  );
  const prices = (field<string[]>(shopItemsResponse, "prices", 3) || []).map(
    (value: string) => Number(formatUnits(value, 18))
  );

  for (let itemId = 0; itemId < 14; itemId++) {
    const ownerPrice = ownerPrices[itemId] ?? prices[itemId] ?? 0;
    const basePrice = basePrices[itemId] ?? 0;
    const listedPrice =
      prices[itemId] ?? (ownerPrice > 0 ? ownerPrice : basePrice);

    shopItems.push({
      categoryId: categoryIds[itemId] ?? 0,
      typeId: typeIds[itemId] ?? itemId,
      stockAmount: stockAmounts[itemId] ?? 0,
      basePrice,
      ownerPrice,
      price: listedPrice,
    });
  }
  return shopItems;
};

export const restockItems = async (account: string, cityId: number) => {
  const restockItems = await writeContractAndWait({
    address,
    abi,
    functionName: "restockItems",
    args: [cityId],
    account,
    gasMultiplier: 5,
  });
  return restockItems;
};

export const updateCityCostPrice = async (
  account: string,
  cityId: number,
  prices: number[]
) => {
  const parsedPrices = prices.map((price) =>
    parseUnits(Number(price).toString(), 18)
  );

  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "updateCityCostPrice",
    args: [cityId, parsedPrices],
    account,
    gasMultiplier: 5,
  });

  return tx;
};

export const claimProfit = async (account: string, cityId: number) => {
  const claimProfit = await writeContractAndWait({
    address,
    abi,
    functionName: "claimProfit",
    args: [cityId],
    account,
  });
  return claimProfit;
};

export const getLastRestockTime = async (cityId: number) => {
  const lastRestockTime: any = await readContract({
    address,
    abi,
    functionName: "cityShopInfo",
    args: [cityId],
  });

  return Number(lastRestockTime);
};

export const getCityCashProfit = async (cityId: number) => {
  const cityCashProfit: any = await readContract({
    address,
    abi,
    functionName: "cityCashProfit",
    args: [cityId],
  });
  return Number(formatUnits(cityCashProfit, 18));
};

export const getRestockInterval = async () => {
  const restockInterval = await readContract({
    address,
    abi,
    functionName: "restockInterval",
  });
  return Number(restockInterval);
};

export const buyItems = async (
  account: string,
  typeIds: number[],
  amounts: number[],
  message: string,
  signature: string
) => {
  const buyItems = await writeContractAndWait({
    address,
    abi,
    functionName: "buyItems",
    args: [typeIds, amounts, JSON.stringify(message), signature],
    account,
  });
  return buyItems;
};

export const getNextBuyTime = async (account: string) => {
  const nextBuyTime = await readContract<string>({
    address,
    abi,
    functionName: "nextBuyTime",
    args: [account],
  });
  return Number(nextBuyTime);
};
